<template>
	<transition name="slide-fade">
		<div
			class="container"
			v-if="active"
		>
			<div
				class="login-form"
			>
				<div
					class="modal-close-x"
					@click="active = false"
					v-html="`x`"
				/>
				<div
					class="section-title" style="padding-top: 50px" 
				>
					<h2
						v-html="`${ $t('components.checkout.login.title') }`"
					/>
					<p>
						<span
							v-html="`${ $t('components.checkout.login.label')} `"
						/>

					</p>
				</div>

				<div
					class="section-content"
				>
					<form
						class="login"
						method="POST"
						@submit.prevent="$_auth_login()"
					>
						<label>
							<input
								name="email"
								type="email"
								autocomplete="email"
								:value="form.email"
								@input="$_auth_inputEmail($event)"
								required
								class="form-control"
								:placeholder='$t("components.checkout.login.email")'
							>
						</label>

						<input-password
							v-model="form.password"
						/>

						<p class="text-right" >
							<router-link
								:to="{ name: 'recovery'}"
								class="link-detail"
								title="Password dimenticata"
								v-html="`Hai dimenticato la password?`"
							/>
						</p>


						<flash
				            :flash="error"
				            :state="state"
				        />


						<div class="flex flex-column">
							<CTA
								:disabled="loadingLogin"
								:content="$t('auth.signin.button')"
								:size="`small`"
							/>
							
							<div
								class="divider"
							>
								{{ $t("components.checkout.login.divider") }}
							</div>

							<div class="flex justify-content-around">
								<v-btn
									large
									outlined
									class="google-btn"
									@click="$_auth_login('google', '/')"
								>
									<i class="fab fa-google fa-1.5x"></i>
									<span class="text-bold capitalize ml-1" style="color: #4285F4">Google</span>
								</v-btn>

								<span class="align-self-center">|</span>

								<CTA
									:disabled="loadingLogin"
									@click="$_auth_login('facebook', '/')"
									:color="`blue`"
									:size="`small`"
									:content="$t('auth.signin.facebook')"
									style="width: 40%"
								/>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>

import { auth } from '../../mixins/login'

import InputPassword from '../Parts/InputPassword'

export default {
	data () {
		return {
			active: false,
			isToShowPassword: false
		}
	},

	components: {
		InputPassword
	},

	mixins: [
		auth
	],

	computed: {
		user () {
			return this.$root.user
		}
	},

	methods: {
		open () {
			this.active = true
		},

		toggleSection () {
			//this.isToShowLogin = !this.isToShowLogin
		},
	}
}
</script>

<style scoped>
h2 {
	text-align: center;
}

.container {
	min-height: 100vh;
	width: 100%;
	position: fixed;
	top: 0;
	bottom: 0;
}

.section-title {
	text-align: center;
}

.divider {
	align-self: center;
	margin: 10px 0;
}

label {
	display: block;
	position: relative;
}

.login-form {
	width: 90%;
	max-width: 300px;
	margin: 98px auto 0 auto;
}

.modal-close-x {
	z-index: 1;
	position: absolute;
	top: 0;
	right: 0;
	width: 42px;
	height: 50px;
	text-align: center;
	color: #9f9c9c;
	border-radius: 100px;
	opacity: 1;
	font-size: 35px;
	border: none;
	cursor: pointer;
	font-weight: bold;
	transform: scaleX(1.1);
	z-index: 1;
	line-height: 1.2;
}

.google-btn {
	width: 40%;
	display: inline-block;
	border: 1px solid #4285F4;
}

.fa-google {
  background: conic-gradient(from -45deg, #ea4335 110deg, #4285f4 90deg 180deg, #34a853 180deg 270deg, #fbbc05 270deg) 73% 55%/150% 150% no-repeat;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}

</style>
